var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-empty-wrapper"},[_c('div',{staticClass:"wrapper-icon"},[_c('font-awesome-icon',{attrs:{"icon":"sad-cry"}})],1),_c('div',{staticClass:"wrapper-content"},[_c('div',{staticClass:"desc"},[_vm._v(" "+_vm._s(_vm.description)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }